'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { PropertyCategories } from '../../../constants/properties';
import { i18nKey } from '../../../utils/properties';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SettingsLink(props) {
  const {
    settingsKey,
    href
  } = props;
  if (![PropertyCategories.SITE_SETTINGS].includes(settingsKey)) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: i18nKey(`help.settings.${settingsKey}.helpLink`),
    options: {
      href
    }
  });
}
SettingsLink.propTypes = {
  href: PropTypes.string.isRequired,
  settingsKey: PropTypes.string
};